<template>
	<div id="main-container">
			<configuration-index-edit
				ref="ref_configurationIndexEdit"
				:visible="modalState_editConfiguration"
				@mutatedConfiguration="mutatedConfiguration"
				@createdNewConfiguration="createdNewConfiguration"
				@deletedConfiguration="deletedConfiguration"
			></configuration-index-edit>
			<!-- div class="col-2" id="div-query-panel" style="max-height: 200px">
				<div
					class="card col-2 bg-light"
					id="customer-order-index-query"
					v-bind:style="{ height: `${tHeight}px`, position: 'fixed', 'max-width': '16.2%', 'overflow-y': 'scroll', }"
				>
					<div class="card-body bg-light px-0" style="background: #f2f2f2">
						< !--form @submit.prevent="onSubmit" -- >
							<label class="col-12 px-0">Gruppe:
								<b-input
									class="col-12"
									size="sm"
									type="text"
									v-model="query.group"
									@keypress.enter="submit()"
								/>
							</label>
							<b-row class="pt-2">
								<b-col class="pr-3">
									<b-button
										id="submit-button"
										size="sm"
										block
										variant="primary"
										@click="submit()"
										>
										filtern
									</b-button>
								</b-col>
							</b-row>
							< !-- div v-for="ff in fastFilterStrings" :key="ff" class="pr-1">
								<b-row class="pt-2 pr-3">
									<b-col class="pr-0 my-1">
										<b-button
											block
											size="sm"
											variant="outline-primary"
											@click="fastFilter(ff)"
											>
											{{ff}}
										</b-button>
									</b-col>
								</b-row>
							</div -- >
					</div>
				</div>
			</div -->
		<!-- div class="col-12 float-right" -->
		<div>
			<b-overlay
				id="overlay-coi-list-card"
				:show="queryInProgress"
				variant="light"
				opacity="0.5"
				blur="2px"
				rounded="lg"
				><!-- overlay -->
				<b-card class="mx-3 mt-1">
					<div class="row" id="coi-pagination">
						<div class="col-md-2">
							<div class="d-flex justify-content-start pt-3">
								<h3 pt-3>Konfiguration</h3>
							</div>
						</div>
						<div class="col-md-10">
							<div class="d-flex flex-row justify-content-end">
								<div class="d-flex flex-row-reverse">
									<div class="pl-2 py-2">
										<b-button size="md" @click="createConfiguration()">Config hinzufügen</b-button>
									</div>
									<div class="py-2">
										<b-form-select
											id="per-page-select"
											v-model="perPage"
											:options="pageOptions"
											size="md"
										></b-form-select>
									</div>
									<div class="p-2">
										<b-pagination
											id="table-pagination-configurations-schedule"
											class="float-right"
											v-if="configurations"
											v-model="currentPage"
											:total-rows="configurations.length"
											:per-page="perPage"
											aria-controls="table-configurations-schedule"
										></b-pagination>
									</div>
								</div>
							</div>
						</div>
					</div>

					<b-table
						class="mt-3"
						:items="configurations"
						:fields="fields"
						:per-page="perPage"
						:current-page="currentPage"
						small
						hover
						><!-- b-table -->
						<template v-slot:cell(configGroup)="x">
							<a @click="editConfiguration(x.item)" class="link2">{{ x.item.configGroup }}</a>
						</template>
						<template v-slot:cell(label)="x">
							<span v-if="!x.item.label" />
							<a v-else-if="x.item.label.length < 25" @click="editConfiguration(x.item)" class="link2">{{x.item.label}}</a>
							<a v-else @click="editConfiguration(x.item)" class="link2">{{x.item.label.substr(0, 25)}}...</a>
						</template>
						<template v-slot:cell(configKey)="x">
							<span v-if="!x.item.configKey" />
							<a v-else-if="x.item.configKey.length < 25" @click="editConfiguration(x.item)" class="link2">{{x.item.configKey}}</a>
							<a v-else @click="editConfiguration(x.item)" class="link2">{{x.item.configKey.substr(0, 25)}}...</a>
						</template>
						<template v-slot:cell(configValue)="x">
							<span v-if="!x.item.configValue" />
							<a v-else-if="x.item.configValue.length < 50" @click="editConfiguration(x.item)" class="link2">{{ x.item.configValue }}</a>
							<a v-else @click="editConfiguration(x.item)" class="link2">{{x.item.configValue.substr(0, 50)}}...</a>
							<!-- textarea
								v-else
								v-model="x.item.configValue"
								rows="1"
								minlength="1"
								style="min-width: 500px"
							></textarea>
							< textarea
								v-else-if="x.item.configValue.length < 160"
								v-model="x.item.configValue"
								style="min-width: 500px"
								rows="2"
								minlength="2"
							></textarea>
							<textarea
								v-else-if="x.item.configValue.length < 240"
								v-model="x.item.configValue"
								rows="3"
								minlength="3"
							></textarea>
							<textarea
								v-else
								v-model="x.item.configValue"
								rows="5"
								minlength="5"
							></textarea -->
						</template>
						<template v-slot:cell(description)="x">
							<span v-if="!x.item.description" />
							<a v-else-if="x.item.description.length < 25" @click="editConfiguration(x.item)" class="link2">{{x.item.description}}</a>
							<a v-else @click="editConfiguration(x.item)" class="link2">{{x.item.description.substr(0, 25)}}...</a>
						</template>

						<template v-slot:cell(lastUpdateTime)="x">
							<span v-if="!x.item.lastUpdateTime" />
							<a v-else-if="x.item.lastUpdateTime.length < 25" @click="editConfiguration(x.item)" class="link2">{{x.item.lastUpdateTime}}</a>
							<a v-else @click="editConfiguration(x.item)" class="link2">{{x.item.lastUpdateTime.substr(0, 25)}}...</a>
						</template>

					</b-table>
				</b-card>
			</b-overlay>
		</div>
	</div>
</template>
<style scoped>
.link2 {
	color: #131313 !important;
}
.link2:hover {
	color: #25bf43 !important;
	cursor: pointer;
}
</style>
<script>
export default {
	data() {
		return {
			query: { group: "" },
			queryInProgress: false,
			configurations: [],
			configurationEdit: null, // config to be edited
			modalState_editConfiguration: false,
			perPage: 1000,
			currentPage: 1,
			pageOptions: [25, 100, 250, 1000],
			tHeight: this.window.innerHeight - 75,
			fields: [
				//Id Config Group Label Description Config Key Config Value Possible Values Last Update Time Last Update User Last Update Reason
				{ key: "id", label: "ID", sortable: true },
				{ key: "configGroup", label: "Gruppe", sortable: true },
				{ key: "label", label: "Label", sortable: true },
				{ key: "description", label: "Beschreibung", sortable: true },
				{ key: "configKey", label: "Key", sortable: true },
				{ key: "configValue", label: "Wert", sortable: true },
				{ key: "possibleValues", label: "zulässige Werte", sortable: true },
				{ key: "lastUpdateTime"
				, label: "geändert am"
				, sortable: true
				, formatter: function(s) { return s ? moment(s).format("DD.MM.YYYY HH:mm") : "-" }
				},
				{ key: "lastUpdateUser", label: "User", sortable: true },
				{ key: "lastUpdateReason", label: "Änderungsgrund", sortable: true },
				//{ key: "name", label: "Titel", sortable: true, /* tdClass: 'table-danger' */ }
			],
		};
	},

	methods: {
		createdNewConfiguration(configuration)
		{
			this.configurations.push(configuration);
		},
		mutatedConfiguration(mutant)
		{
			// not sure if this overwrites the object with ref of mutant or if this copys mutant over
			// to configurationEdit by value. Yes, the reference in this.configurationEdit **is**
			// overwritten by the ref of mutant. This means, to keep this.configurationEdit's original
			// reference, we cannot use the "=" operator directly on it, but call it on all keys of
			// said object.
			for(const k of Object.keys(this.configurationEdit)) this.configurationEdit[k] = mutant[k];
		},
		deletedConfiguration(configurationId) {
			let ret = [];
			for(let k = 0; k < this.configurations.length; ++k)
			{
				if(this.configurations[k].id === configurationId) {
					delete this.configurations[k];
				}else{
					ret.push(_.clone(this.configurations[k]));
				}
			}
			this.configurations = ret;
		},
		createConfiguration() {
			this.configurationEdit = {
				id: "",
				configGroup: "",
				label: "",
				description: "",
				configKey: "",
				configValue: "",
				possibleValues: "",
				lastUpdateReason: "",
				lastUpdateUser: "",
				lastUpdateTime: ""
			};
			this.modalState_editConfiguration = true;
			this.$refs.ref_configurationIndexEdit.open(this.configurationEdit, 'new');
		},
		editConfiguration(config) {
			this.configurationEdit = config; //TODO jobEdit is not necessary.
			this.modalState_editConfiguration = true;
			this.$refs.ref_configurationIndexEdit.open(config, 'mutant');
		}
	},
	created() {
		axios
			.get("/configuration/all")
			.then( response => {
				this.configurations = response.data;
			})
			.catch( error => {
				this.$bvToast.toast( "Daten konnten nicht runtergeladen werden.", {
               title: "Configuration Index",
               autoHideDelay: 32000,
               appendToast: false,
               variant: 'danger'
            });
				console.error(error);
			});
	},
};
</script>
